export default __webpack_public_path__ + "41586fd22305423c2c4dded511ebd5e5.png";